import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Cookie } from "lucide-react";
import { Link } from "react-router-dom";
import { useLang } from "@/lib/i18n";

export default function CookieBanner() {
  const { t } = useLang();
  const [visible, setVisible] = useState(() => !localStorage.getItem("niva_cookie_ok"));
  const accept = () => {
    localStorage.setItem("niva_cookie_ok", "1");
    setVisible(false);
  };
  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="cookie-banner"
          role="dialog"
          aria-label="Cookies"
          initial={{ y: 40, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 40, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1], delay: 0.8 }}
          className="fixed bottom-4 left-4 right-4 z-[60] mx-auto max-w-xl rounded-2xl border border-white/10 bg-coal/95 p-5 shadow-2xl backdrop-blur-xl sm:left-6 sm:right-auto sm:bottom-6"
        >
          <div className="flex items-start gap-4">
            <Cookie className="mt-0.5 h-5 w-5 shrink-0 text-mint" />
            <div className="flex-1">
              <p className="text-sm leading-relaxed text-bone/85">
                {t("cookie.text")}{" "}
                <Link data-testid="cookie-privacy-link" to="/integritetspolicy" className="text-mint hover:underline">
                  {t("footer.privacy")}
                </Link>
                .
              </p>
              <button
                data-testid="cookie-accept-button"
                onClick={accept}
                className="mt-4 rounded-full bg-mint px-5 py-2 text-xs font-bold text-ink transition-colors hover:bg-bone"
              >
                {t("cookie.ok")}
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
